module.exports = __webpack_public_path__ + "img/right_course.bd67a002.png";